
















import { Component, Mixins, Model, Prop, Watch, Emit } from "vue-property-decorator";
import { FormatReference } from "../../../domain/format";
import { Patient } from "../../../domain/patient";
import NewDocumentFormatSelector from "../selectors/NewDocumentFormatSelector.vue";

@Component({
  components: {
    formatSelector: NewDocumentFormatSelector,
  },
})
export default class NewDocumentFormatSelectorDialog extends Mixins() {
  @Model("input")
  value: FormatReference;

  @Prop({ default: false })
  isEmbedded: boolean;

  @Prop()
  patient: Patient;

  @Prop()
  formatId: number;

  @Prop()
  formatIds: number[];

  @Prop({ default: null })
  formatName: string;

  @Prop()
  folderId: string;

  @Prop()
  defaultFormatTabName: string;

  @Prop()
  documentKindIds: number[];

  @Prop()
  isVisible: boolean;

  @Prop()
  validateSelectedFormat: (selected?: FormatReference) => Promise<boolean>;

  data(): any {
    return {
      selectedItem: null as FormatReference,
    };
  }
  selectedItem: FormatReference;

  @Watch("selectedItem")
  onSelectedItemUpdated(newValue: FormatReference, oldValue: FormatReference) {
    if (this.validateSelectedFormat !== undefined) {
      this.validateSelectedFormat(newValue)
      .then(isOk => {
        if (!isOk) { return; }
        this.input(newValue);
      });
    } else {
      this.input(newValue);
    }
  }

  @Emit()
  input(value: FormatReference): void {}
}
